import { Dialog, Button } from "@mui/material";
import colorConfigs from "../../../config/colorConfigs";
import { formatUSPhone } from "../../../utils/phoneFormatter";

type Props = {
    popup: boolean;
    hidePopup: () => void;
    particularCustomerEnquiryDetails: any;
}

export default function CustomerEnquiriesInfo({
    popup,
    hidePopup,
    particularCustomerEnquiryDetails
}: Props) {

    return (
        <Dialog
            open={popup}
            onClose={hidePopup}
            fullWidth
            maxWidth="md"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '16px',
                    height: '50vh',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >

            <div className="flex justify-between items-center px-6 py-4 border-b">
                <h2 className="text-lg font-semibold text-secondary">
                    Customer Enquiry
                </h2>

                <button
                    onClick={hidePopup}
                    className="text-gray-500 hover:text-red-500 transition"
                >
                    <span className="material-symbols-outlined text-[20px]">
                        close
                    </span>
                </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-6">
                <div className="grid grid-cols-2 gap-6">

                    <div className="flex flex-col gap-1">
                        <span className="text-xs font-semibold text-secondary">
                            Customer Name
                        </span>
                        <span className="text-sm text-secondary">
                            {particularCustomerEnquiryDetails?.name}
                        </span>
                    </div>

                    <div className="flex flex-col gap-1">
                        <span className="text-xs font-semibold text-secondary">
                            Email Address
                        </span>
                        <span className="text-sm text-secondary">
                            {particularCustomerEnquiryDetails?.email}
                        </span>
                    </div>

                    <div className="flex flex-col gap-1">
                        <span className="text-xs font-semibold text-secondary">
                            Phone Number
                        </span>
                        <span className="text-sm text-secondary">
                            {formatUSPhone(particularCustomerEnquiryDetails?.phone)}
                        </span>
                    </div>

                    <div className="col-span-2 flex flex-col gap-1">
                        <span className="text-xs font-semibold text-secondary">
                            Question
                        </span>
                        <span className="text-sm text-secondary break-words">
                            {particularCustomerEnquiryDetails?.question}
                        </span>
                    </div>

                </div>
            </div>

            <div className="flex justify-end px-6 py-4 border-t bg-white">
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: colorConfigs.btn.cancel.bg,
                        border: colorConfigs.btn.cancel.border,
                        color: colorConfigs.btn.cancel.color
                    }}
                    onClick={hidePopup}
                >
                    Close
                </Button>
            </div>
        </Dialog>
    );
}